import PropTypes from 'prop-types';
import { Box, Card, CardContent, Chip, Tooltip, Typography, alpha } from '@mui/material';
import { ACTION_META, LABEL_META, convStrength, fmtDec } from './shared';

const TopPerLabelSection = ({ heroLabels, summary, t }) => {
  if (!summary?.top_per_label) return null;

  return (
    <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' }}>
      {heroLabels.filter((label) => label !== 'FAKE_SUPPORT_OR_EXIT').map((label) => {
        const meta = LABEL_META[label];
        const tickers = summary.top_per_label[label] || [];

        if (tickers.length === 0) return null;

        return (
          <Card key={label} sx={{ flex: '1 1 280px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)', border: '1px solid rgba(0,0,0,0.08)' }}>
            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
              <Box sx={{ px: 2, py: 1.25, borderBottom: '2px solid rgba(0,0,0,0.08)', bgcolor: alpha(meta.color, 0.04), display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ color: meta.color, display: 'flex', '& svg': { fontSize: 18 } }}>{meta.icon}</Box>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: meta.color }}>
                  {t('behavior.top', { title: t(`behavior.labels.${label}.title`) })}
                </Typography>
              </Box>
              {tickers.map((tickerItem, index) => {
                const conviction = convStrength(tickerItem.conviction);
                const actionColor = ACTION_META[tickerItem.tactical_action]?.color || '#94a3b8';

                return (
                  <Box
                    key={tickerItem.ticker}
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      px: 2,
                      py: 0.75,
                      borderBottom: index < tickers.length - 1 ? '1px solid rgba(0,0,0,0.04)' : 'none',
                      '&:hover': { bgcolor: alpha(meta.color, 0.02) },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                      <Typography sx={{ fontSize: '0.7rem', color: '#94a3b8', fontWeight: 600, width: 16, flexShrink: 0 }}>{index + 1}</Typography>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontSize: '0.82rem', fontWeight: 700 }}>{tickerItem.ticker}</Typography>
                        {tickerItem.company_name && (
                          <Typography sx={{ fontSize: '0.68rem', color: '#64748b', lineHeight: 1.3 }}>
                            {tickerItem.company_name}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                      {tickerItem.tactical_action && (
                        <Chip
                          label={t(`behavior.actions.${tickerItem.tactical_action || 'IGNORE'}`)}
                          size="small"
                          sx={{ height: 16, fontSize: '0.55rem', fontWeight: 600, bgcolor: alpha(actionColor, 0.1), color: actionColor }}
                        />
                      )}
                      <Tooltip title={`Điểm xác tín: ${tickerItem.conviction > 0 ? '+' : ''}${fmtDec(tickerItem.conviction)} / 50`} arrow placement="top">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.4, cursor: 'default' }}>
                          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: conviction.color, flexShrink: 0 }} />
                          <Typography sx={{ fontSize: '0.65rem', fontWeight: 700, color: conviction.color, whiteSpace: 'nowrap' }}>
                            {conviction.label}
                          </Typography>
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                );
              })}
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

TopPerLabelSection.propTypes = {
  heroLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  summary: PropTypes.shape({
    top_per_label: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.shape({
      ticker: PropTypes.string,
      company_name: PropTypes.string,
      tactical_action: PropTypes.string,
      conviction: PropTypes.number,
    }))),
  }),
  t: PropTypes.func.isRequired,
};

TopPerLabelSection.defaultProps = {
  summary: null,
};

export default TopPerLabelSection;